import { type ReactNode } from 'react';

import { CardDescription } from '@/microfrontends/listing/shared/containers/listing-cards/containers/desktop/CardDescription';
import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors';

export function CardDescriptionContainer(): ReactNode {
  const { description } = useCardOfferDataContext();

  return <CardDescription description={description} rowsAmount={6} />;
}
